module.exports = __webpack_public_path__ + "img/SA3.21cc5d03.png";